import { ErrorStateCode } from '../../components/error-state/error-state.type';

export const ERROR_PAGE_CODE = [401, 403, 404, 500, 503] as const;
export type ErrorPageCode = (typeof ERROR_PAGE_CODE)[number];

export const isErrorPageCode = (code: number): code is ErrorPageCode => {
  return ERROR_PAGE_CODE.map((item) => item as number).includes(code);
};

export const errorPageCodeStateCode: Record<ErrorPageCode, ErrorStateCode> = {
  401: 'unauthorized',
  403: 'forbidden',
  404: 'notFound',
  500: 'internalServerError',
  503: 'serviceUnavailable',
};
